import { CollectionItem, Container } from "Component";
import classNames from "classnames";

const Item = ({
  id,
  name,
  billing,
}: {
  id: string;
  name: string;
  billing: { active: boolean; needsAttention: boolean };
}) => {
  const alert = billing?.needsAttention || !billing?.active;
  const success = !alert;
  return (
    <CollectionItem id={id}>
      <Container row style={{ flex: 1 }}>
        <span
          style={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          }}
        >
          {name}
        </span>
      </Container>
      <Container row>
        <span className={classNames({ alert, success })}>
          {alert ? "unhealthy" : "healthy"}
        </span>
      </Container>
    </CollectionItem>
  );
};

export default Item;
